/**
 * Parse a date-only string (YYYY-MM-DD) as a local calendar day.
 * Avoids `new Date("YYYY-MM-DD")`, which is UTC midnight and shifts
 * the displayed day backward in US timezones.
 */
export function parseLocalDate(dateStr: string): Date {
  if (!dateStr) return new Date(NaN);
  const dateOnly = dateStr.trim().slice(0, 10);
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateOnly);
  if (match) {
    const year = Number(match[1]);
    const month = Number(match[2]) - 1;
    const day = Number(match[3]);
    return new Date(year, month, day);
  }
  // Fallback for ISO datetimes / other formats
  return new Date(dateStr);
}

/** Local date + optional HH:mm time. */
export function parseLocalDateTime(dateStr: string, timeStr?: string): Date {
  const base = parseLocalDate(dateStr);
  if (Number.isNaN(base.getTime())) return base;
  if (timeStr) {
    const [h, m] = timeStr.split(":").map(Number);
    if (!Number.isNaN(h)) base.setHours(h, Number.isNaN(m) ? 0 : m, 0, 0);
  }
  return base;
}

export function startOfLocalDay(d: Date): Date {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}
